module.exports = __webpack_public_path__ + "img/MA.caaf228d.svg";